export default () => ({
	apiToken: window.API_TOKEN,
});
